module.exports = __webpack_public_path__ + "static/media/screen3.b19a4bf2.png";